import React from 'react';
import { useRecoilValue } from 'recoil';
import { lookupState } from 'state/atoms';

import { Product } from 'components';
import Header from 'pages/NewCaseSearch/subcomponents/Header';
import AddToRma from 'pages/NewCaseSearch/subcomponents/AddToRma';
import IncorrectPartNumber from 'pages/NewCaseSearch/subcomponents/IncorrectPartNumber';
import RmaFiels from 'pages/NewCaseSearch/subcomponents/RmaFields';
import { WarrantyActions } from 'pages/NewCaseSearch/styledComponents';
import { Flex } from 'components/layout/Flex';

const inWarrantyMessage = 'This item is covered under warranty';

const InWarranty = () => {
  const { lookupResults, selectedResult } = useRecoilValue(lookupState);
  const { serialNumber, product } = selectedResult;
  const headerCard = [{ title: 'Serial #:', value: serialNumber }];

  return (
    <Flex direction="column">
      {lookupResults.length === 1 ? <Header cards={headerCard} /> : null}
      <Flex>
        <Flex direction="column" spacing="space-between" grow="1">
          <Product
            statusType="info"
            statusMessage={inWarrantyMessage}
            {...product}
          />
          <RmaFiels />
        </Flex>

        <WarrantyActions>
          <AddToRma />
          {lookupResults.length === 1 ? <IncorrectPartNumber /> : null}
        </WarrantyActions>
      </Flex>
    </Flex>
  );
};

export default InWarranty;
